<template>
    <div id="hero" class="form-container home-step" :ref="stepName" style="position:relative">
        <p>Offre réservée aux nouveaux membres</p>
        <h2>Découvrez Test&nbsp;Achats<br>pendant 2 mois pour 2&nbsp;€&nbsp;!</h2>
        <p>Et choisissez votre cadeau de bienvenue parmi des dizaines de marques</p>
        <b-button class="button is-primary next-button" @click="nextStep()">Recevoir mon pack à 2€</b-button>
        <p>Les marques du catalogue peuvent être sujettes à modification</p>

        <b-loading :is-full-page="false" v-model="loading"></b-loading>
    </div>
</template>

<script>
import {gsap} from 'gsap';
import mixin from "../../../travel_step_mixin";
import ScrollLink from "../../../../../../views/_commons/fr/ScrollLink";
import animation_mixin from "../../../animation_engine_mixin";

export default {
    mixins: [mixin],
    components:{ScrollLink},
    mounted(){

    }
}
</script>
